export default __webpack_public_path__ + "static/media/img_twilight_0.8c4c3e77.png";